import React from "react"
import { Legend as AntdLegend } from '@empglabs/backoffice-ui-kit'

const Legend = props => {
  return <AntdLegend {...props} />
}

export default Legend
